// a lógica agora se concentra em createAutocompleteController.js
import { createAutocompleteController } from "./createAutocompleteController"
import { useGrupoAtivos } from "./useGrupoAtivos"

export const useGrupoAtivosAutocompleteController = createAutocompleteController(useGrupoAtivos)